import * as React from "react";
import { type RouteProps } from "react-router";
import { PermissionRoute } from "../../Common/Routing/PermissionRoute";

const GiftCards = React.lazy(() => import("./GiftCards"));
const GiftCardsImport = React.lazy(() => import("./GiftCardsImport"));

export default function GiftCardIndex(): Array<React.ReactElement<RouteProps>> {
    return [
        <PermissionRoute
            permissions={[ "manage_gift_cards" ]}
            title="Gift Cards | Shopfront"
            path="/giftcards"
            key="giftcards"
            element={<GiftCards />}
        />,
        <PermissionRoute
            permissions={[ "manage_gift_cards" ]}
            title="Import Gift Cards | Shopfront"
            path="/giftcards/import"
            key="giftcards-import"
            element={<GiftCardsImport />}
        />,
    ];
}
